interface IConfig {
  hostDomain: string;
  defaultTenantSubdomain?: string;
  applicationId: string;
  apiBaseUrl: string;
  ssoDomain: string;
  tenantBucket: string;
  plugins: { url: string }[];
  pluginLoaderTimeoutMs: number;
}

export class EnvConfigService {
  /**
   * Returns the config from window.env.
   *
   * But how did window.env get populated?
   *
   * In production this is loaded via a script tag in index.prod.html.
   *
   * In development this is loaded via a dynamically injected script tag by development.tsx
   *
  */
  getConfig(): IConfig {
    return (window as any).env;
  }
}



// WEBPACK FOOTER //
// ./src/support/EnvConfigService.ts